import styled, { keyframes } from 'styled-components';

const spinnerAnimation = keyframes`
  0%, 100% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 1.5);
  }
  75% {
    transform: scale(1, 1);
  }
`;

const spinnerBeforeAnimation = keyframes`
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1.5);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
`;

const spinnerAfterAnimation = keyframes`
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
`;

const Spinner = styled.div<{ color: string }>`
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: ${({ color }) => (color ? color : '#9880ff')};
  color: ${({ color }) => (color ? color : '#9880ff')};
  animation: ${spinnerAnimation} 1s infinite linear;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${({ color }) => (color ? color : '#9880ff')};
    color: ${({ color }) => (color ? color : '#9880ff')};
    animation: ${spinnerBeforeAnimation} 1s infinite linear;
  }

  &::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${({ color }) => (color ? color : '#9880ff')};
    color: ${({ color }) => (color ? color : '#9880ff')};
    animation: ${spinnerAfterAnimation} 1s infinite linear;
  }
`;

export default Spinner;
